import Google from './Google-view';

export default Google;
